import { isPlatform } from '@ionic/react';
import { UAParser } from 'ua-parser-js';
import { StandalonePage } from './StandalonePage';
import { TrackingService } from '../support/tracking/TrackingService';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useEffect } from 'react';
import { StoreConfigs } from './config/StoreConfigs';

export const UnsupportedPage = () => {
    // if the BrowserAuthenticationClientRedirecter callback fails to deep link back into
    // the app, we will land on this page with the hash #/oath/code
    const isOnAuthCallback = window.location.hash.startsWith('#/oauth/code');

    // if the redirect_uri is lost from state during the auth flow, the api AuthRouter will
    // fall back to WEB_BASE_URL, which on ios will result in the ASWebAuthSession window
    // landing on this page with error params
    const params = new URLSearchParams(window.location.hash.split('?')[1]);
    const isAuthError = params.has('error_description') || params.has('error');

    // in either case, show an auth-specific error message
    const isAuthFailure = (isAuthError || isOnAuthCallback);

    const tracker = useInstance(TrackingService);

    useEffect(() => {
        if (isAuthFailure) {
            tracker.track('Auth Redirect Failed');
        } else if (isPlatform('ios') || isPlatform('android')) {
            tracker.track('Unsupported Mobile Web');
        } else {
            tracker.track('Unsupported Browser', () => {
                const { browser, device, os, ua } = new UAParser().getResult();
                return {
                    browser: `${browser.name} ${browser.version}`,
                    device: `${device.vendor} ${device.model} ${device.type || ''}`.trim(),
                    os: `${os.name} ${os.version}`,
                    ua
                };
            });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const onStoreLinkClicked = () => {
        tracker.track('Opened Store Link from Unsupported');
    };

    if (isAuthFailure) {
        return (
            <StandalonePage showLogo>
                <div style={{maxWidth: 300, margin: '0 auto'}}>
                    <p>Sorry, something went wrong, and we were unable to sign you in. Please close the window and try again.</p>
                </div>
            </StandalonePage>
        );
    }

    return (
        <StandalonePage showLogo>

            {isPlatform('ios') &&
                <div style={{maxWidth: 300, margin: '0 auto'}}>
                    <p>To use AutoPylot on this device, please download it from the <a href={StoreConfigs.ios.installURL} onClick={onStoreLinkClicked}>App Store</a>.</p>
                </div>
            }

            {isPlatform('android') &&
                <div style={{maxWidth: 300, margin: '0 auto'}}>
                    <p>To use AutoPylot on this device, please download it from the <a href={StoreConfigs.android.installURL} onClick={onStoreLinkClicked}>Play Store</a>.</p>
                </div>
            }

            {!isPlatform('ios') && !isPlatform('android') &&
                <div style={{maxWidth: 350, margin: '0 auto'}}>
                    <p>Oops! This browser is not supported.</p>
                    <p>
                        For the optimal experience, we recommend using the latest version of <a href="https://www.google.com/chrome/dr/download/" target="_blank">Chrome</a>.
                        (AutoPylot also works on the latest versions of Safari, Firefox, and Edge.)
                    </p>
                    <p>Or <a href="https://autopylot.io">download our app</a> to use AutoPylot on your phone or tablet.</p>
                </div>
            }

        </StandalonePage>
    );
};
